"use client";

import { handlePostAnalytics, analyticEvents } from "@/apiUtils/analyticsUtils";
import { analyticEventTypes, EyeTestEventActions } from "@/apiUtils/constants";
import { StoreType, TestTypeSectionContent } from "@/common/lib/types";
import { FC, useEffect, useState } from "react";
import EyeTestTypeView from "./view";
import { useParams } from "next/navigation";
import { getServices } from "@/api/mReserve/bookingApi";

interface EyeTestTypeProps {
  storeDetails?: StoreType;
  content?: TestTypeSectionContent;
}

const EyeTestType: FC<EyeTestTypeProps> = ({ storeDetails, content }) => {
  const { locale } = useParams();
  const [services, setServices] = useState<Array<{ id: number; name: string; description: string }>>([]);
  const [loading, setLoading] = useState(true);

  // Fetch services from mReserve API on component mount
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const mReserveServices = await getServices(locale as string);
        setServices(mReserveServices);
      } catch (error) {
        console.error("Error fetching services:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, [locale]);

  const handleClickEvent = (type: string) => {
    handlePostAnalytics({
      eventType: analyticEventTypes.CUSTOM,
      data: {
        target: analyticEvents.BOOK_EYE_TEST,
        bookEyeTestData: {
          eventAction: EyeTestEventActions.TEST_TYPE,
          eventLabel: type,
        },
      },
    });
  };

  return (
    <EyeTestTypeView
      storeDetails={storeDetails}
      content={content}
      handleClickEvent={handleClickEvent}
      services={services}
      loading={loading}
      locale={locale as string}
    />
  );
};

export default EyeTestType;
